const moment = require("moment");
const shortid = require("shortid");

exports = module.exports = function(id) {
	if (!id) {
		return false;
	}
	if (typeof id !== "string") {
		return false;
	}

	var splits = id.split("-");
	if (!splits[1]) {
		return false;
	}

	var ts = moment.unix(splits[0]).isValid();

	var isId = shortid.isValid(splits[1]);

	if (ts && isId) {
		return true;
	} else {
		return false;
	}
};
